import React from "react";
import { useToast, MToastProvider } from "@/components/ui/atoms/MToastProvider";

const ToastTest: React.FC = () => {
  const { showToast } = useToast();

  const handleUndo = () => {
    // Your undo logic here
    showToast({
      message: "Undo action triggered!",
      variant: "success",
    });
  };

  return (
    <div style={{ padding: 32 }}>
      <h2>MToastProvider + useToast Demo</h2>
      <div
        style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}
      >
        <button onClick={() => showToast({ message: "Default toast!" })}>
          Show Default
        </button>
        <button
          onClick={() => showToast({ message: "Info toast!", variant: "info" })}
        >
          Show Info
        </button>
        <button
          onClick={() =>
            showToast({
              message: "Success toast!",
              variant: "success",
              duration: 5000,
            })
          }
        >
          Show Success
        </button>
        <button
          onClick={() =>
            showToast({ message: "Warning toast!", variant: "warning" })
          }
        >
          Show Warning
        </button>
        <button
          onClick={() =>
            showToast({ message: "Alert toast!", variant: "alert" })
          }
        >
          Show Alert
        </button>
        <button
          onClick={() =>
            showToast({
              message: "Error toast!",
              variant: "error",
              duration: 50000,
            })
          }
        >
          Show Error
        </button>
        <button
          onClick={() =>
            showToast({
              message: "TOP toast!",
              variant: "success",
              position: "top",
            })
          }
        >
          Show Top Toast
        </button>
        <button
          onClick={() =>
            showToast({
              message: "BOTTOM toast!",
              variant: "info",
              position: "bottom",
            })
          }
        >
          Show Bottom Toast
        </button>
        <button
          onClick={() =>
            showToast({
              message: "Success! Your changes have been saved successfully.",
              variant: "success",
            })
          }
        >
          Show Success Desc
        </button>
        <button
          onClick={() =>
            showToast({
              message: "Error! Something went wrong. Please try again.",
              variant: "error",
            })
          }
        >
          Show Error Desc
        </button>
      </div>
      <button
        onClick={() =>
          showToast({
            message: "This is a toast with CTA!",
            showCTA: { label: "Undo", onClick: handleUndo },
            duration: 0,
          })
        }
        style={{ marginBottom: 16 }}
      >
        Show CTA Toast
      </button>
    </div>
  );
};

export default ToastTest;
